import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { REWARD_DEFAULTS } from "@/lib/site";

const inputCls = "w-full px-3 py-2 rounded-xl border border-border bg-background outline-none focus:border-primary text-sm";

const Field = ({ label, children }) => (
  <label className="flex flex-col gap-1 text-xs font-semibold text-muted-foreground">{label}{children}</label>
);

export const RewardProgramForm = () => {
  const { settings, reload } = useSite();
  const [form, setForm] = useState({ ...REWARD_DEFAULTS, ...(settings?.reward_program || {}) });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", { reward_program: { ...form, amount: Number(form.amount) || 0 } });
      reload();
      toast.success("Programa de recompensas salvo");
    } catch {
      toast.error("Erro ao salvar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-border p-4 sm:p-5" data-testid="reward-program-form">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div>
          <h2 className="font-bold text-slate-900">Ícone flutuante e regras</h2>
          <p className="text-xs text-muted-foreground">O que o visitante vê ao tocar no ícone de prêmio do site.</p>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold">{form.active ? "Ativo" : "Desativado"}</span>
          <Switch checked={!!form.active} onCheckedChange={(v) => setForm((f) => ({ ...f, active: v }))} data-testid="reward-active-switch" />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Field label="Texto do ícone flutuante"><input className={inputCls} value={form.button_label} onChange={set("button_label")} data-testid="reward-button-label" /></Field>
        <Field label="Valor do prêmio (R$)"><input type="number" min={0} step="0.01" className={inputCls} value={form.amount} onChange={set("amount")} data-testid="reward-amount-input" /></Field>
        <Field label="Título"><input className={inputCls} value={form.title} onChange={set("title")} data-testid="reward-title-input" /></Field>
        <Field label="Seu perfil do Instagram (@)"><input className={inputCls} value={form.instagram} onChange={set("instagram")} placeholder="@seuperfil" data-testid="reward-instagram-input" /></Field>
        <Field label="Texto do botão do Instagram"><input className={inputCls} value={form.cta_text} onChange={set("cta_text")} data-testid="reward-cta-input" /></Field>
        <div className="sm:col-span-2">
          <Field label="Regras (aparecem para o visitante)">
            <textarea rows={6} className={inputCls} value={form.rules} onChange={set("rules")} placeholder={"1. Siga nosso perfil\n2. Poste um Stories marcando nosso perfil\n3. ..."} data-testid="reward-rules-input" />
          </Field>
        </div>
      </div>
      <button type="button" onClick={save} disabled={saving} data-testid="reward-program-save"
        className="mt-4 bg-primary text-primary-foreground font-semibold rounded-full px-6 py-2.5 text-sm hover:opacity-90 transition-opacity disabled:opacity-60">
        {saving ? "Salvando..." : "Salvar"}
      </button>
    </div>
  );
};

export default RewardProgramForm;
